// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.messenger-page{
    width: 800px;
    max-width: 100%;
    margin-top: 15px;
    height: calc(100vh - 105px);
    overflow-y: scroll;
}

.messenger-page .tools-bar{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}

.messenger-page .tools-bar .search-tools{
    display: flex;
    align-items: center;
    
} 

.messenger-page .tools-bar .search-tools .search-bar{
    background-color: #fcfbfe;
    width: 300px;
    border-radius: 14px;
    display: flex;
    border: 1px solid #fcfcfc;
    align-items: center;
    transition: var(--main-transition);
    padding:  8px;
    border: 1px solid #f9f9f9 ;
    box-shadow: 1px 1px 1px #EEE;
}

@media(max-width:550px){
    .messenger-page .tools-bar .search-tools .search-bar{
        width: 200px;
    }
}

.messenger-page .tools-bar .search-tools .search-bar .magnify{
    color: #b3b3b5;
    margin: 0px 5px;
}

.messenger-page .tools-bar .search-tools .save-btn{
    background-color: transparent;
    border: none;
    cursor: pointer;
    margin: 0px 7px;
    transition: var(--main-transition);
    width: 36px;
    height: 36px;
    border-radius: 50%;
}

.messenger-page .tools-bar .search-tools .selected-ids{
    display: flex;
    align-items: center;
}

.messenger-page .tools-bar .search-tools .selected-ids img {
    width: 18px ;
    height: 18px;
    margin: 0px 5px;
}

.messenger-page .tools-bar .search-tools .selected-ids .text-selected-color{
    color: #707276;
}

.messenger-page .tools-bar .search-tools .save-btn:hover{
    background-color: #EEE;
}
.messenger-page .tools-bar .search-tools .save-btn svg{
    color: #b3b3b5;
    font-size: 17px;
}

.messenger-page .tools-bar .search-tools .search-bar-active{
    border: 1px solid var(--main-color);
}

.messenger-page .tools-bar .search-tools .search-bar input{
    width: 100%;
    border: none;
    color: #b3b3b5;

    background-color: transparent;
}

.messenger-page .tools-bar .search-tools .search-bar input:focus{
    outline: none;
}


.messenger-page .tools-bar .extract-btn{
    background-color: var(--main-color);
    border: none;
    color: white;
    font-weight: bold;
    border-radius: 6px;
    width: 160px;
    height: 37px;
    transition: var(--main-transition);
    cursor: pointer;
    font-size: 13px;
}

@media(max-width :600px){
    .messenger-page .tools-bar .extract-btn{
        margin-top: 10px;
    }
}

.messenger-page .tools-bar .extract-btn:hover{
    opacity: .8;
}


.messenger-page .table{
    background-color: white;
    margin-top: 14px;
    border-radius: 14px;
    box-shadow: 1px 1px 1px #EEE;
}
.messenger-page .table .table-header{
    padding: 10px 15px;
    display: flex;
    border-bottom:2px solid #f9f9f9 ;
}

.messenger-page .table .table-header .col{
    width: calc((100% - 40px) / 3);
    display: flex;
    font-weight: bold;
    justify-content: center;
}


.messenger-page .table .table-header .col:first-child{
    width: 40px;
}

.table .table-body .table-row{
    display: flex;
    padding: 13px 15px;

}

.table .table-body{
    display: flex;
    flex-direction: column;
}

.table .table-body .table-row .col:first-child{
    width: 40px;

}

.table .table-body .table-row .col{
    width: calc((100% - 40px) / 3);
    display: flex;
    /* color: #6d7379;
    font-weight: 600; */
    
    overflow: hidden;
    justify-content: center;
}

.table .table-body .table-row{
transition: var(--main-transition);

}

.table .table-body .table-row:hover{
    background-color: #f2f8fd;
}

.table .table-body .table-row-loading:hover{
    background-color: transparent;
}



.table .table-body .table-row .col input ,
.messenger-page .table .table-header .col input {
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Messengers/messengers.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;IAClC,aAAa;IACb,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;;IAEd,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,mCAAmC;IACnC,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb;uBACmB;;IAEnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;AACA,kCAAkC;;AAElC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;;;AAIA;;IAEI,eAAe;AACnB","sourcesContent":["\n.messenger-page{\n    width: 800px;\n    max-width: 100%;\n    margin-top: 15px;\n    height: calc(100vh - 105px);\n    overflow-y: scroll;\n}\n\n.messenger-page .tools-bar{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.messenger-page .tools-bar .search-tools{\n    display: flex;\n    align-items: center;\n    \n} \n\n.messenger-page .tools-bar .search-tools .search-bar{\n    background-color: #fcfbfe;\n    width: 300px;\n    border-radius: 14px;\n    display: flex;\n    border: 1px solid #fcfcfc;\n    align-items: center;\n    transition: var(--main-transition);\n    padding:  8px;\n    border: 1px solid #f9f9f9 ;\n    box-shadow: 1px 1px 1px #EEE;\n}\n\n@media(max-width:550px){\n    .messenger-page .tools-bar .search-tools .search-bar{\n        width: 200px;\n    }\n}\n\n.messenger-page .tools-bar .search-tools .search-bar .magnify{\n    color: #b3b3b5;\n    margin: 0px 5px;\n}\n\n.messenger-page .tools-bar .search-tools .save-btn{\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    margin: 0px 7px;\n    transition: var(--main-transition);\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n}\n\n.messenger-page .tools-bar .search-tools .selected-ids{\n    display: flex;\n    align-items: center;\n}\n\n.messenger-page .tools-bar .search-tools .selected-ids img {\n    width: 18px ;\n    height: 18px;\n    margin: 0px 5px;\n}\n\n.messenger-page .tools-bar .search-tools .selected-ids .text-selected-color{\n    color: #707276;\n}\n\n.messenger-page .tools-bar .search-tools .save-btn:hover{\n    background-color: #EEE;\n}\n.messenger-page .tools-bar .search-tools .save-btn svg{\n    color: #b3b3b5;\n    font-size: 17px;\n}\n\n.messenger-page .tools-bar .search-tools .search-bar-active{\n    border: 1px solid var(--main-color);\n}\n\n.messenger-page .tools-bar .search-tools .search-bar input{\n    width: 100%;\n    border: none;\n    color: #b3b3b5;\n\n    background-color: transparent;\n}\n\n.messenger-page .tools-bar .search-tools .search-bar input:focus{\n    outline: none;\n}\n\n\n.messenger-page .tools-bar .extract-btn{\n    background-color: var(--main-color);\n    border: none;\n    color: white;\n    font-weight: bold;\n    border-radius: 6px;\n    width: 160px;\n    height: 37px;\n    transition: var(--main-transition);\n    cursor: pointer;\n    font-size: 13px;\n}\n\n@media(max-width :600px){\n    .messenger-page .tools-bar .extract-btn{\n        margin-top: 10px;\n    }\n}\n\n.messenger-page .tools-bar .extract-btn:hover{\n    opacity: .8;\n}\n\n\n.messenger-page .table{\n    background-color: white;\n    margin-top: 14px;\n    border-radius: 14px;\n    box-shadow: 1px 1px 1px #EEE;\n}\n.messenger-page .table .table-header{\n    padding: 10px 15px;\n    display: flex;\n    border-bottom:2px solid #f9f9f9 ;\n}\n\n.messenger-page .table .table-header .col{\n    width: calc((100% - 40px) / 3);\n    display: flex;\n    font-weight: bold;\n    justify-content: center;\n}\n\n\n.messenger-page .table .table-header .col:first-child{\n    width: 40px;\n}\n\n.table .table-body .table-row{\n    display: flex;\n    padding: 13px 15px;\n\n}\n\n.table .table-body{\n    display: flex;\n    flex-direction: column;\n}\n\n.table .table-body .table-row .col:first-child{\n    width: 40px;\n\n}\n\n.table .table-body .table-row .col{\n    width: calc((100% - 40px) / 3);\n    display: flex;\n    /* color: #6d7379;\n    font-weight: 600; */\n    \n    overflow: hidden;\n    justify-content: center;\n}\n\n.table .table-body .table-row{\ntransition: var(--main-transition);\n\n}\n\n.table .table-body .table-row:hover{\n    background-color: #f2f8fd;\n}\n\n.table .table-body .table-row-loading:hover{\n    background-color: transparent;\n}\n\n\n\n.table .table-body .table-row .col input ,\n.messenger-page .table .table-header .col input {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
